<template>
  <b-modal ref="modal" no-close-on-backdrop no-close-on-esc>
    <template #modal-header>
      <h5>Bitte warten...</h5>
    </template>
    <b-container>
      <b-spinner variant="outline-primary"></b-spinner>
    </b-container>
    <template #modal-footer>
      <b-button @click="$emit('modalConfirmed')" variant="outline-primary">Abbrechen und Ausloggen</b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "LoadingModal",
  props: {
    show: Boolean
  },
  emits: {
    modalConfirmed: null
  },
  mounted() {
    if(this.show) {
      this.$refs["modal"].show()
    } else {
      this.$refs["modal"].hide()
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    show(newVal) {
      this.$refs["modal"].toggle()
    }
  }
}
</script>

<style scoped>
</style>
